import { render } from "./KWEdit.vue?vue&type=template&id=22891d29"
import script from "./KWEdit.vue?vue&type=script&lang=js"
export * from "./KWEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__